import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';

export const useInvalidateInvestmentsList = (mipId: string) => {
	const queryClient = useQueryClient();

	return useCallback(
		() =>
			queryClient.invalidateQueries({
				queryKey: [
					formatUnicorn(
						API_PATHS.MIP_MIPID_INVESTOR_INVESTMENT_WORKFLOW_MIP_INVESTMENTS_LIST_POST,
						{ mipId }
					),
				],
			}),
		[queryClient, mipId]
	);
};
